import {Component, OnInit, HostBinding} from '@angular/core';
import {Router} from '@angular/router';


@Component({
  selector: 'app-noInternet',
  templateUrl: 'noInternet.component.html',
  styleUrls: ['noInternet.component.scss'],
})
export class noInternetComponent implements OnInit {
  @HostBinding('class.noInternetHost') hostClass = false;

  constructor(protected router: Router) {
    this.hostClass = true;
  }

  ngOnInit() {}

  goHome() {
    this.router.navigate(['']);
  }
}



// WEBPACK FOOTER //
// ./src/app/template/noInternet/noInternet.component.ts